/**
 * リスト検索結果
 * 共通部品
 */
<template>
	<tr class="tr-td-control" 
		:class="class_info" 
		:style="row_style"
		@click="onTr">
		<td v-for="(item ,index) in r_items" :class="item.class" @click="onTdClick(item.type)">
<!-- 共通アイテム -->
			<span v-if="item.type == 'btn_check'" class="check-box-btn">
	<!-- [チェック]ボタン -->
				<el-checkbox :value="r_info.isSelect" @change="onBtnCheck"></el-checkbox>
			</span>
			<span v-if="item.type == 'btn_detail' && disp_btnDetail">
	<!-- [詳細]ボタン -->
				<!-- <button	class="more-detail-btn fa fa-file-text" @click="onBtnDetail" v-bind:class="{'disable-color': r_info.isDelete}" :disabled="r_detail_disabled"></button> -->
				<button	class="more-detail-btn" @click="onBtnDetail" v-bind:class="{'disable-color': r_info.isDelete}" :disabled="r_detail_disabled"><i class="fa-solid fa-file-lines"></i></button>
			</span>
			<span v-else-if="item.type == 'btn_edit'">
	<!-- [編集]ボタン -->
				<!-- <button class="editing-btn fa fa-pencil" @click="onBtnChange" v-bind:class="{'active-color': r_info.isChange, 'disable-color': r_info.isDelete}" ></button> -->
				<button class="editing-btn" @click="onBtnChange" v-bind:class="{'active-color': r_info.isChange, 'disable-color': r_info.isDelete}"><i class="fa-solid fa-pencil"></i></button>
			</span>
			<span v-else-if="item.type == 'btn_edit_disable'">
	<!-- [編集]ボタン(無効) -->
				<button class="editing-btn active-color fa fa-pencil" v-show="!r_info.isDelete"></button>
			</span>
			<span v-else-if="item.type == 'btn_dummy'">
	<!-- ボタンダミー -->
			</span>
			<span v-else-if="item.type == 'btn_add'">
	<!-- [追加]ボタン -->
				<button class="editing-btn glyphicon glyphicon-plus" @click="onBtnAdd" v-show="!r_info.isDelete"></button>
			</span>
	<!-- 使用状況 -->
			<span v-else-if="item.type == 'using_status'">
				<button class="display-btn" @click="onBtnUsingStatus" v-bind:class="{'disable-color': r_info.isDelete}"> {{"表示"}} </button>
			</span>
	<!-- 登録日時 -->
			<span v-else-if="item.type == 'txt_create'" :title="changeDate(r_info.create_timestamp)">
				{{ changeDate(r_info.create_timestamp) }}
			</span>
	<!-- 更新日時 -->
			<span v-else-if="item.type == 'txt_uptime'" :title="changeDate(r_info.update_timestamp)">
				{{ changeDate(r_info.update_timestamp) }}
			</span>
	<!-- 更新日時(TZ変換) -->
			<span v-else-if="item.type == 'txt_conv_uptime'" :title="r_info.conv_update_timestamp">
				{{ r_info.conv_update_timestamp }}
			</span>
	<!-- 更新者 -->
			<span v-else-if="item.type == 'txt_upuser'" :title="r_info.update_user">
				{{ r_info.update_user }}
			</span>
	<!-- 更新者2 -->
			<span v-else-if="item.type == 'txt_upuser_id'" :title="r_info.update_user_id">
				{{ r_info.update_user_id }}
			</span>
	<!-- [削除]ボタン -->
			<span v-else-if="item.type == 'btn_delete' && disp_btnDelete">
				<button class="delete-btn fa fa-trash" @click="onBtnDelete"  v-bind:class="{'active-color': r_info.isDelete}"></button>
			</span>
	<!-- カスタムスロット -->
			<span v-else-if="item.type == 'slot'">
				<slot :name="item.name"></slot>
			</span>
	<!-- テキスト(キー指定) -->
			<span v-else-if="item.type == 'txt_key'">
				{{ r_info[item.name] }}
			</span>
	<!-- テキスト(キー指定2) -->
			<span v-else-if="item.type == 'txt_key2'">
				{{ getParam2(r_info,item.name,item.name2) }}
			</span>
	<!-- テキスト(キー指定3) -->
			<span v-else-if="item.type == 'txt_key3'">
				{{ getParam3(r_info,item.name,item.name2,item.name3) }}
			</span>
	<!-- テキスト(直接指定) -->
			<span v-else-if="item.type == 'txt_fn'">
				{{ item.fn(index,r_y_index) }}
			</span>
	<!-- ブランク -->
			<span v-else>
				
			</span>
		</td>
	</tr>
</template>
<script>
export default {

/**
 {
		"type": "btn/txt_static/txt_edit"
 }
*/
		mixins: [
		],
		props:{
			"r_id":{},
			"r_info":{},		//!< 表示するデータ
			"r_items":{},		//!< 表示する項目の定義
			"r_y_index":{},		//!< 縦インデックス
			"r_disp":{
				type:Object,
				default: function(){return {};}
			}, //! < 表示制御 
			'r_detail_disabled': false, // 詳細ボタンdisabled
			'r_detail_notDisplay': false, // 詳細ボタン非表示

			'r_index':0,
		},
		data: function (){
			//! 表示用に段組みして格納
			return {
			};
		},
		computed:{
			class_info:function(){
				let temp ="";
				if(this.r_info){
					temp += this.r_info["isDelete"]?'tr-datadelete ':"";
					temp += this.r_info["isSelect"]?'tr-dataselect ':"";
					temp += this.r_info["isSelect"]?'tr-select ':"";
					temp += this.r_info["isChange"]?'tr-edit ':"";
					temp += this.r_info["row_class"]?this.r_info["row_class"] +" ":"";
				}
				if (this.r_index != undefined) {
					temp += 'row-'+this.r_index;
				}
				return temp;
			},
			row_style:function(){
				if( this.r_info["row_style"] ){
					return this.r_info["row_style"];
				}
				return "";
			},
			// 詳細ボタンを表示するか
			disp_btnDetail: function (){
				if ( this.r_detail_notDisplay ) {
					return false;
				}
				if ( this.r_disp == null || this.r_disp.btnDetail  == null ) {
					return true;
				}
				return this.r_disp.btnDetail;
			},
			// 削除ボタンを表示するか
			disp_btnDelete: function (){
				if ( this.r_disp == null || this.r_disp.btnDelete  == null ) {
					return true;
				}
				return this.r_disp.btnDelete;
			},
		},
		methods: {
			getParam2:function(info,key1,key2){
				if(info[key1] != undefined &&
					info[key1][key2] != undefined  ){
					return info[key1][key2];
				}
				return "";
			},
			getParam3:function(info,key1,key2,key3){
				if(info[key1] != undefined &&
					info[key1][key2] != undefined &&
					info[key1][key2][key3] != undefined ){
					return info[key1][key2][key3];
				}else{
//console.log("getParam3 error : " + key1 +"," + key2 + "," +key3);
//console.log(info);
				}
				return "";
			},
			/*
			* チェックボタン
			*/
			onTdClick:function( type ) {
				this.$emit("event_td_click",type);
			},
			/*
			* チェックボタン
			*/
			onBtnCheck:function( e ) {
				this.$emit("event_check",this.r_id,this.r_info);
			},
			/*
			* 詳細ボタン押下
			*/
			onBtnDetail:function( e ) {
				console.log("listItem - onBtnDetail");
				if (this.r_info.isDelete) return;
				this.$emit("event_detail",this.r_id,this.r_info);
			},
			/*
			* 消去ボタン押下
			*/
			onBtnDelete:function( e ) {
				this.$emit("event_delete",this.r_id,this.r_info);
			},
			/*
			* 編集ボタン押下
			*/
			onBtnChange:function( e ) {
				console.log("listItem - onBtnChange");
				if (this.r_info.isDelete) return;
				this.$emit("event_change",this.r_id,this.r_info);
			},
			/*
			* 追加ボタン押下
			*/
			onBtnAdd:function( e ) {
				this.$emit("event_add",this.r_id,this.r_info);
			},
			/*
			* 使用状況表示ボタン押下
			*/
			onBtnUsingStatus: function(e){
				console.log("listItem - onBtnUsingStatus");
				if (this.r_info.isDelete) return;
				this.$emit("event_using_status", this.r_id, this.r_info);
			},
			/*
			* 列クリックイベント
			*/
			onTr:function( e ) {
				this.$emit("event_tr",this.r_id,this.r_info);
			},
			/*
			* タイムスタンプを返還
			*/
			changeDate:function( ts ) {
				if (!ts){
					return "";
				}
				if(typeof ts == "string"){
					return ts;
				}
				var d = new Date( ts * 1000 );
				var year  = d.getFullYear();
				var month = d.getMonth() + 1;
				month = ( month	< 10 ) ? '0' + month   : month;
				var day  = ( d.getDate()	< 10 ) ? '0' + d.getDate() : d.getDate();
				var hour = ( d.getHours()	< 10 ) ? '0' + d.getHours()   : d.getHours();
				var min  = ( d.getMinutes()	< 10 ) ? '0' + d.getMinutes() : d.getMinutes();

				return year + '-' + month + '-' + day + ' ' + hour + ':' + min;
			},
		},
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/parts_com/listItem.vue